import { errorToast, successToast } from '@/components/Toast';
import { NotificationType, notifyActions } from './slice';
import { all, takeEvery } from 'redux-saga/effects';
import { SagaPayload } from '../common/types';

export function* errorNotificationsSaga() {
  yield all([takeEvery(notifyActions.setNotification, showNotifications)]);
}

// eslint-disable-next-line @typescript-eslint/no-deprecated
type Action<T extends keyof typeof notifyActions> = SagaPayload<
  (typeof notifyActions)[T]
>;

function* showNotifications({ payload }: Action<'setNotification'>) {
  for (const n of payload) {
    switch (n.type) {
      case NotificationType.Error:
        void errorToast({ description: n.text, autoClose: 10000 });
        break;
      case NotificationType.Success:
        void successToast({ description: n.text, autoClose: 10000 });
        break;
    }
  }
}
